import { createTheme } from "@material-ui/core/styles";

const lightTheme = createTheme({
  typography: {
    fontFamily: ["Poppins", "cursive"].join(","),
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*": {
          "scrollbar-width": "thin",
          "scrollbar-color": "#C7C7C3 #DDDDDB",
        },
        "*::-webkit-scrollbar-track": {
          background: "#dddddb",
        },
        "*::-webkit-scrollbar-thumb": {
          background: "#C7C7C3",
          "border-radius": "20px",
          border: "3px solid #DDDDDB",
        },
      },
    },
  },
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    background: {
      paper: "#fff",
      default: "#f7f7f7",
    },
    primary: {
      light: "#98c360",
      main: "#7FB539",
      dark: "#587e27",
      contrastText: "#fff",
    },
    secondary: {
      light: "#434166",
      main: "#151240",
      dark: "#0e0c2c",
      contrastText: "#fff",
    },
    error: {
      light: "#f37b71",
      main: "#F15B4E",
      dark: "#a83f36",
      contrastText: "#fff",
    },
    text: {
      primary: "#000000",
      secondary: "#757575",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
    },
    custom: {
      color_1: "#151240",
      color_2: "#F15B4E",
      color_3: "#5C2A4F",
      color_4: "#B9B8C6",
    },
    fisica: {
      backgroundColor: "#55B3C9",
      color: "#48438A",
    },
    quimica: {
      backgroundColor: "#5663CD",
      color: "#FBC124",
    },
    biologia: {
      backgroundColor: "#FAB938",
      color: "#FFFFFF",
    },
    ciencias: {
      backgroundColor: "#d96c64",
      color: "#2e2d29",
    },
  },
});

export default lightTheme;
